(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	/* The following defined the Routes related Login, Registration etc. */
	ngModule.config(function($stateProvider, $urlRouterProvider) {
		$stateProvider
			.state('start', {
				abstract: true,
				url: '/',
                templateUrl: 'templates/layout.html'
			})
			.state('home', {
				url: '/',
                views: {
                    content: {
                        templateUrl: 'templates/home.html',
                        controller: function($scope, $state) {
                            $scope.goToTeamStore = function() {
                                if($scope.storeId){
                                    $state.go('singleStore', {id: $scope.storeId});
                                } else {
                                    var storeId = '-KTqZFrkyM1Mi4T_-mXS';
                                    $state.go('singleStore', {id: storeId});
                                }
                            }
                        }
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                },
                needsAuth: false
			})
            .state('singleStore', {
                needsAuth: false,
				url: '/storefront/:id',
                params: {
                    id: null
                },
                views: {
                    content: {
                        templateUrl: 'directives/externalStore/table.html',
                        controller: 'SingleStoreCtrl'
                    },
                    nav: {
                        templateUrl: 'templates/nav.html',
                        controller: 'SingleStoreNavController'
                    }
                },
                resolve: {
                    storeId: function($stateParams) {
                        return $stateParams.id;
                    },
                    // do we need this? seems redundant
                    // TODO: review this, check SingleStoreNavController
                    store: function($stateParams, $Stores){

                        return $Stores.getStoreWithPromise($stateParams.id).then((store) => {

                            // console.log('singleStore -> resolve -> store', store);
                            return store;
                        });
                    }
                    // store: function($stateParams) {
                    //     return $Stores.get($stateParams.id);
                    // }
                }
			})
            //http://localhost:3000/#/storefront/-KNNMdzT4rW8tXdDLKG1/myorder/-KSSOXj6Wgtm7uGxJOJo
            .state('singleOrder', {
                needsAuth: false,
				url: '/storefront/:id/:orderId',
                params: {
                    id: null,
                    orderId: null,
                },
                views: {
                    content: {
                        templateUrl: 'directives/externalStore/singleOrder.html',
                        controller: function($scope, storeId, orderId, $Orders, $http, $timeout) {

                            $scope.order = false;

                            $Orders.getOrderByStore(storeId, orderId).then( (orderDetails) => {
                                console.log('orderDetails', orderDetails);
                                $scope.order = orderDetails;

                            });

                        }
                        //controller: 'SingleStoreCtrl'
                    },
                    nav: {
                        templateUrl: 'templates/nav.html',
                        //controller: 'SingleStoreNavController'
                    }
                },
                resolve: {
                    storeId: function($stateParams) {
                        return $stateParams.id;
                    },
                    orderId: function($stateParams) {
                        return $stateParams.orderId;
                    }
                }
			})
            .state('teamOrders', {
                url: '/teamorder/:id',
                params: {
                    id: null
                },
                views: {
                    content: {
                        templateUrl: 'directives/externalStore/teamOrders.html',
                        controller: function($scope, storeId) {

                            $scope.storeId = storeId;

                        }
                    },
                    nav: {
                        templateUrl: 'templates/nav.html',
                    }
                },
                resolve: {
                    storeId: function($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
			.state('account', {
				url: '/account',
                needsAuth: true,
                views: {
                    content: {
                        template: '<user-account></user-account>',
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                },
			})
            .state('customPaymentGenerator', {
                url: '/generate-custom-payment',
                needsAuth: true,
                views: {
                    content: {
                        templateUrl: 'templates/customerPaymentGeneratorForm.html',
                        controller: 'CustomPaymentGeneratorFormCtrl'
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                },
            })
            .state('customPayment', {
                url: "/custom-payment?customer_name&customer_organization&customer_note&amount",
                needsAuth: false,
                views: {
                    content: {
                        templateUrl: 'templates/customerPaymentForm.html',
                        controller: 'CustomPaymentCtrl'
                        // controller: function ($scope, $stateParams) {
                        //     console.log('blooe ploasdewrd', $stateParams);
                        //
                        //     $scope.order = {
                        //         customer_name: $stateParams.customer_name,
                        //         customer_organization:  $stateParams.customer_organization,
                        //         amount: $stateParams.amount
                        //     };
                        // },
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                },
            })
            // $stateParams
			.state('stores', {
				url: '/stores',
                needsAuth: true,
                views: {
                    content: {
                        templateUrl: 'templates/store/table.html',
                        controller: 'StoreCtrl'
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                }
			})
            // .state('order-detail', {
            //     url: '/stores/:id/:orderId'
            // })
            .state('store-detail', {
				url: '/stores/:id',
                needsAuth: true,
                views: {
                    content: {
                        template: '<store-detail store="store"></store-detail>',
                        controller: function($scope, store) {
                            $scope.store = store;
                        }
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                },
                resolve: {
                    store: function($Stores, $stateParams) {
                        if($stateParams.id){
                            return $Stores.get($stateParams.id);
                        } else {
                            return {};
                        }
                    }
                }
			})
			.state('products', {
				url: '/products',
                needsAuth: true,
                views: {
                    content: {
                        template: '<product-list></product-list>'
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                }
			})
            .state('product-detail', {
				url: '/products/:id',
                needsAuth: true,
                views: {
                    content: {
                        template: '<product-detail product="product"></product-detail>',
                        controller: function($scope, product) {
                            $scope.product = product;
                        }
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                },
                resolve: {
                    product: function($Products, $stateParams) {
                        if($stateParams.id){
                            return $Products.get($stateParams.id);
                        } else {
                            return {
    		                    name: '',
    		                    description: '',
    		                    basePrice: 0
        		            };
                        }
                    }
                }
			})
			.state('teams', {
				url: '/teams',
                needsAuth: true,
                views: {
                    content: {
                        template: '<team-list></team-list>',
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                }
			})
			.state('users', {
				url: '/users',
                needsAuth: true,
                views: {
                    content: {
                        template: '<user-list></user-list>',
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                },
                needsAuth: true
			})
			.state('orders', {
				url: '/orders',
                needsAuth: true,
                views: {
                    content: {
                        template: '<store-orders-table></store-orders-table>',
                        controller: 'OrderCtrl'
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                }
			})
            .state('order-detail', {
				url: '/orders/:id',
                needsAuth: true,
                params: {
                    id: null
                },
                views: {
                    content: {
                        template: '<order-detail order="order"></order-detail>',
                        controller: function($scope, order) {
                            $scope.order = order;
                        }
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                },
                resolve: {
                    order: function($Orders, $stateParams) {
                        return $Orders.get($stateParams.id);
                    }
                }
			})
			.state('tabs', {
				url: '/tabs',
                needsAuth: true,
				templateUrl: 'templates/demo/tabs.html',
                controller: 'TabsCtrl'
			})
			.state('login', {
				url: '/login',
                needsAuth: false,
                views: {
                    content: {
                        templateUrl: 'templates/login.html',
                        controller: 'LoginCtrl'
                    },
                    nav: {
                        templateUrl: 'templates/nav.html'
                    }
                }
			});

		$urlRouterProvider.otherwise('/');
	});

})();
